import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { AppState } from '../../../../types/store';
import {
  batchLoadTiers,
  selectBatchAction,
  batchMerge,
  batchMoveToStash,
  batchMoveToDrafts,
  batchUnpublish,
} from '../../../../actions/studio';
import { getIsRootFolder } from '../../../../selectors/studio';
import {
  confirmMoveSelectionToFolder,
  createFolderFromSelection,
} from '../../../../actions/studio/folders';
import { Props } from './MenuSection';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

export type StateProps = Pick<Props, 'tiers' | 'isLoading' | 'isRootFolder'>;
export type DispatchProps = Pick<
  Props,
  | 'selectBatchAction'
  | 'batchMerge'
  | 'batchLoadTiers'
  | 'pushTierCreateModal'
  | 'confirmMoveSelectionToFolder'
  | 'createFolderFromSelection'
  | 'batchMoveToStash'
  | 'batchMoveToDrafts'
  | 'batchUnpublish'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  tiers: state.studio?.tiers,
  isLoading: state.studio?.batchActionLoading,
  isRootFolder: getIsRootFolder(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  selectBatchAction,
  batchLoadTiers,
  batchMerge,
  pushTierCreateModal: () => pushModal(ModalType.STUDIO_TIER_CREATE, { wrapInModal: false }),
  confirmMoveSelectionToFolder,
  createFolderFromSelection,
  batchMoveToStash,
  batchMoveToDrafts,
  batchUnpublish,
};

export default connect(mapStateToProps, mapDispatchToProps);
